<div class="translation-key">
    <c-input type="text" model-property="$ctrl.item.translationKey" model-validation="$ctrl.config.validation"></c-input>
</div>
<div class="system-translation" ng-bind-html="$ctrl.systemTranslation()"></div>
<div class="language-string">
    <c-language-string-input value="$ctrl.item.value" languages="$ctrl.config.languages" validation="$ctrl.config.validation" label="Translation" />
</div>
<div class="remove-translation"><i class="fa fa-times" ng-click="$ctrl.removeTranslation()"></i></div>